'use client';

import LoadingSpinner from '@/app/(football)/[team]/_components/common/LoadingSpinner';

/**
 * Game loading screen component
 * Displayed during game initialization
 */
export function LoadingOverlay() {
  return (
    <div className="absolute inset-0 z-8 flex items-center justify-center bg-black/80">
      <div className="flex flex-col items-center gap-6">
        {/* Loading spinner */}
        <LoadingSpinner size={48} />

        {/* Loading text */}
        <p className="typo-body-1 text-g-00">로딩 중...</p>
      </div>
    </div>
  );
}
